import produce from 'immer';
import { AnyAction } from 'redux';
import {
  FETCH_COMPANY_SUCCESS,
  FETCH_COMPANY_TOKEN_ERROR,
  FETCH_COMPANY_TOKEN_LOADING,
  FETCH_COMPANY_TOKEN_SUCCESS
} from '../ActionTypes';
import { ICompanyTokenResponse } from 'interfaces';

type InitialStateType = {
  loading: boolean;
  loaded: boolean;
  error: string | null;
  data: ICompanyTokenResponse;
};

export const INIT_STATE: InitialStateType = {
  loading: false,
  loaded: false,
  error: null,
  data: {} as ICompanyTokenResponse
};

export const CompanyReducer = (
  state = INIT_STATE,
  action: AnyAction
): InitialStateType =>
  produce(state, draft => {
    switch (action.type) {
      case FETCH_COMPANY_TOKEN_LOADING:
        draft.loading = true;
        draft.loaded = false;
        draft.error = '';
        break;

      case FETCH_COMPANY_TOKEN_SUCCESS:
        draft.loading = false;
        draft.loaded = true;
        draft.data = action.payload.company;
        break;

      case FETCH_COMPANY_TOKEN_ERROR:
        draft.loading = false;
        draft.loaded = true;
        draft.error = action.payload;
        break;

      case FETCH_COMPANY_SUCCESS:
        draft.loading = false;
        draft.loaded = true;
        draft.data = action.payload.data;
        break;
    }
  });
